// extracted by mini-css-extract-plugin
module.exports = {"filter":"BrandFilterItem-module--filter--5fb2df","label":"BrandFilterItem-module--label--3ac6de","overflowEllipsis":"BrandFilterItem-module--overflowEllipsis--481fec"};